import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { IsDefined, ValidateNested } from 'class-validator';
import { DEFAULT_RECEIPT_NOTES, ReceiptNotes } from './ReceiptNotes';
/**
 * The court system's configuration for order receipts
 */
export class ReceiptsConfiguration {
    /**
     * @param notes Text to appear on receipts, if visible
     */
    constructor(notes) {
        this.notes = notes;
    }
}
__decorate([
    IsDefined(),
    ValidateNested(),
    Type(() => ReceiptNotes),
    __metadata("design:type", ReceiptNotes
    /**
     * @param notes Text to appear on receipts, if visible
     */
    )
], ReceiptsConfiguration.prototype, "notes", void 0);
export const DEFAULT_RECEIPTS_CONFIGURATION = new ReceiptsConfiguration(DEFAULT_RECEIPT_NOTES);
